export default {
  translations: {
    webcast: {
      buttonGroup: {
        slide: `Slide`,
        video: `Video`,
        split: `Dividir`,
      },
      supportTab: {
        tooltip: `Suporte Técnico`,
        content: `email: atendimento@riprisma.com`,
      },
      downloadFileTab: {
        tooltip: `Arquivos`,
      },
      connectionTab: {
        tooltip: `Conexão`,
      },
      chatTab: {
        tooltip: `Digite sua mensagem...`,
        title: `Chat`,
        button: `Enviar`,
        unvaibleMessage: `Chat indisponível no momento.`,
      },
      chatButton: {
        text: `Q&A`,
      },
      inviteTab: {
        label: `Email`,
        tooltip: `Convidar`,
        button: `Convidar`,
        inviteSent: `O convite foi enviado com sucesso.`,
        errorEmptyEmail: `É obrigatório informar o email.`,
        errorInvalidEmail: `O email informado foi considerado inválido.`,
        errorCharactersEmail: `Campo email permite no máximo 200 caracteres`,
        errorSendEmail: `Erro ao enviar email.`,
      },
      infoTab: {
        tooltip: `Info`,
      },
      speakerTab: {
        tooltip: `Palestrantes`,
      },
      eventFinished: {
        browserTitle: `O Evento terminou`,
        title: `Seu evento ao vivo disponível na web`,
        castFinished: `Evento terminado`,
        castMessage: `Este Evento foi encerrado.`,
      },
      eventStarts: {
        title: `Aguardando`,
        castStarts: `Previsão de início:`,
        castMessage: `Consulte sua caixa de entrada para mais informações`,
      },
      eventClosed: {
        closed: `Aguardando`,
        castClosed: `Agradecemos seu interesse`,
      },
      requirements: {
        tooltip: `Página de Requisitos`,
        title: `Requerimentos`,
        content: {
          title: `Problemas de conexão`,
          version: `versão`,
          higher: `ou superior`,
          download: `Baixe a versão mais recente *`,
          browser: `Navegador`,
          wsUpdates: `e todas as atualizações da Microsoft`,
          processorTitle: `Processador`,
          processorTxt: `Intel Pentium 4 ou equivalente com processador de 1 GHz `,
          ram: `256MB RAM (512 MB recomendado) `,
          resolution: `Resolução Mínima`,
          resolutionNote: `Nota`,
          resolutionNoteTxt: `Essas configurações são submetidas a testes regulares para cada versão do produto. Outros ambientes, tais como Linux e diferentes versões do navegador, também podem funcionar, mas não são recomendados.`,
          mobile: `Dispositivos móveis compatíveis`,
          portDomainTitle: `Portas e Domínios`,
          portDomainTxt: `A sua rede ou computador pode ter um firewall que bloqueia nossos serviços. Certifique-se de que os seguintes domínios, IPs e portas não estão bloqueados pela rede e/ou computador.`,
          ports: `Portas`,
          protocols: `Protocolos`,
          antiVirus: `Antivírus e antimalware podem também bloquear nossos domínios e portas, causando problemas. Verifique se algo está sendo bloqueado por esses tipos de software.`,
          urlAvailability: `(*) A disponibilidade dos URLs listados acima é de responsabilidade dos fabricantes e pode sofrer alterações sem aviso prévio. Se esses URLs não estiverem disponíveis, recomendamos realizar uma pesquisa no site do fabricante ou uitilizar algum mecanismo de pesquisa.`,
        },
      },
      connection: {
        connected: `Sua conexão foi restaurada.`,
        notConnected: `Você perdeu a conexão. tentando se reconectar`,
      },
      of: `de`,
      stanby: `Aguardando`,
      castStart: `Esse Evento começa`,
      term: `Termo de consentimento`,
      liveEvent: `Seu evento ao vivo disponível na web`,
      sidebar: {
        title: `Detalhes deste evento`,
      },
      footer: {
        followButton: `Seguir apresentador`,
      },
      player: {
        playMessage: `Clique aqui para iniciar.`,
      },
    },
    register: {
      loading: `Carregando...`,
      browserTitle: `Registro`,
      labelSubmit: `Entrar`,
      initRegister: `Vamos iniciar seu credenciamento`,
      initRegisterText: `Para participar desse Evento, é necessário preencher as informações abaixo.`,
      conference: `Teleconferência dos`,
      results: `Resultados`,
      name: `Nome`,
      email: `E-mail`,
      company: `Empresa`,
      phone: `Telefone`,
      phoneInfo: `Não são aceitos caracteres especiais (como + ou -)!`,
      userType: `Perfil`,
      selectLabel: `Selecione`,
      termsAcceptMessage: `Ao continuar, você concorda com os`,
      terms: `Termos`,
      dateFormat: `dd/MM/yyyy - HH:mm`,
      acceptTerms: `Declaro que li e aceito a `,
      privacyPolicy: `Política de Privacidade`,
      useTerms: `Termos de Uso`,
      useTermsAnd: `e os`,
      linkTerms: `https://www.riprisma.com/pt/politica-de-privacidade`,
      useTermsPrisma: `da Prisma`,
      validations: {
        name: {
          required: `Campo Nome é obrigatório`,
          max: `Permitido no máximo 200 caracteres.`,
        },
        email: {
          valid: `E-mail inserido inválido`,
          required: `Campo E-mail é obrigatório`,
          max: `Campo E-mail permite no máximo 200 caracteres.`,
        },
        typeUser: {
          required: `Campo Perfil é obrigatório`,
        },
        company: {
          max: `Campo Empresa permite no máximo 400 caracteres.`,
        },
        phone: {
          max: `Campo Telefone permite no máximo 200 caracteres.`,
          required: `Campo Telefone é obrigatório`,
        },
      },
    },
    footer: {
      allRightsReserved: `Todos os direitos reservados`,
    },
  },
};
